import React, { useState } from 'react'
import { IconButton, Box, Modal } from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'
import ReactPlayer from 'react-player'
import PropTypes from 'proptypes'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  videoWrap: {
    position: 'relative',
    paddingBottom: '56.25%',
    height: 0
  },
  video: {
    position: 'absolute',
    top: 0,
    left: 0
  },
  close: {
    position: 'absolute',
    right: -theme.spacing(5),
    top: -theme.spacing(5),
    color: theme.colors.white,
    zIndex: 1,
    fontSize: '2rem',
    [`${theme.breakpoints.down('sm')} and (orientation: portrait)`]: {
      right: -theme.spacing(2),
      top: -theme.spacing(6)
    },
    [`${theme.breakpoints.down('sm')} and (orientation: landscape)`]: {
      right: -theme.spacing(4),
      top: -theme.spacing(4)
    }
  },
  paper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90vw',
    maxWidth: '1000px',
    backgroundColor: theme.colors.blue5,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0),
    outline: 'none',
    [`${theme.breakpoints.down('sm')} and (orientation: portrait)`]: {
      width: '98vw'
    },
    [`${theme.breakpoints.down('sm')} and (orientation: landscape)`]: {
      width: '80vw'
    }
  }
}))

function VideoModal(props) {
  const classes = useStyles(props)
  const [open, setOpen] = useState(false)

  const handleOpen = (e) => {
    e.preventDefault()
    if (props.isInsideText) {
      const el = e.target.closest('A')
      if (el && e.currentTarget.contains(el) && el.href.indexOf('#') > 0) {
        setOpen(true)
      }
    } else {
      setOpen(true)
    }
  }

  const handleClose = () => {
    setOpen(false)
  }
  return (
    <>
      {React.cloneElement(props.children, { onClick: (e) => handleOpen(e) })}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="video-modal"
        aria-describedby="video-modal"
      >
        <Box className={classes.paper}>
          <IconButton onClick={handleClose} className={classes.close}>
            <CancelIcon fontSize="inherit" />
          </IconButton>
          <div className={classes.videoWrap}>
            <ReactPlayer
              className={classes.video}
              controls
              playing={true}
              height="100%"
              width="100%"
              url={props.videoUrl}
            />
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default VideoModal

VideoModal.propTypes = {
  videoUrl: PropTypes.string
}
